import { render, staticRenderFns } from "./quick-add-company-widget.vue?vue&type=template&id=099b2dfe&scoped=true&"
import script from "./quick-add-company-widget.vue?vue&type=script&lang=js&"
export * from "./quick-add-company-widget.vue?vue&type=script&lang=js&"
import style0 from "./quick-add-company-widget.vue?vue&type=style&index=0&id=099b2dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b2dfe",
  null
  
)

export default component.exports